import React, { Component } from "react";
import "../assets/css/style.css";
import "../assets/css/responsive.css";

import MySites from "./mySites";
import MyCertification from "./myCertification";
import MyAchievements from "./myAchievements";
import MyFCCMoments from "./myFccMoments";
import Header from "./header";
import Profile from "./profile";
import RatingsReviews from "./ratingsReview";
import ReviewPopup from "./reviewPopup";
import axios from "axios";

const HOST = process.env.REACT_APP_HOST;
const API = process.env.REACT_APP_API;

// const writeRivew = {
//     // size={40}
//     // value={0}
//     // edit={true}
//     // isHalf={true}
//     size: 30,
//     count: 5,
//     value: 0,
//     isHalf: true,
//     edit: true,
//     emptyIcon: <i className="fa fa-star" />,
//     halfIcon: <i className="fa fa-star-half-alt" />,
//     filledIcon: <i className="fa fa-star" />,
//     color:"#ececec",
//     activeColor:"#FFF700",
//     // onChange={this:ratingChanged}
// };

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: false,
      dataNotFound: false,
      languagesData: {},
      isViewAllSite: false,
      ratingData: {},
      ratingLoading: false,
      isVisibleModal: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true, ratingLoading: true });
    let modal = document.getElementById("myModal");
    window.onclick = function (event) {
      if (event.target === modal) {
        document.body.style.overflow = "visible";
        modal.style.display = "none";
      }
    };
    // const path = window.location.pathname;
    // const pathParams = path.split("/");
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.uuid
    ) {
      axios
        .get(
          `${HOST}${API}digitalcard/details-get/${this.props.match.params.uuid}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("x-access-token"),
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            this.setState({ data: res.data.data });
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          if (
            (err && err.response && err.response.status === 404) ||
            (err && err.response && err.response.status === 400)
          ) {
            this.setState({ dataNotFound: true });
          }
        });
      this.getReview(this.props.match.params.uuid);
    }
  }
  getReview = (uuid) => {
    axios
      .get(`${HOST}${API}digitalcard/list-ratings-and-reviews/?uuid=${uuid}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log(JSON.stringify(response.data));
        this.setState({ ratingData: response.data.data, ratingLoading: false });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({ ratingData: {}, ratingLoading: false });
      });
  };
  modalOpen = () => {
    let modal = document.getElementById("myModal");
    document.body.style.overflow = "hidden";
    modal.style.display = "block";
    this.setState({ isVisibleModal: !this.state.isVisibleModal });
  };

  modalClose = () => {
    let modal = document.getElementById("myModal");
    document.body.style.overflow = "visible";
    modal.style.display = "none";
    this.setState({ isVisibleModal: !this.state.isVisibleModal });
  };

  getLanguages = (childState) => {
    this.setState({
      languagesData: childState && childState.languagesData,
    });
  };
  handleViewAllSite = (value) => {
    // const {isViewAllSite} = this.state;
    this.setState({ isViewAllSite: value });
  };
  setRatingLoading = (value) => {
    this.setState({ ratingLoading: value });
  };
  render() {
    const {
      data,
      loading,
      dataNotFound,
      languagesData,
      isViewAllSite,
      ratingData,
      ratingLoading,
      isVisibleModal,
    } = this.state;
    return (
      <div className="site-wrappper">
        <Header
          certificates={data.certificates_details}
          setLanguage={this.getLanguages}
          achievements={data.achievement_details}
          siteDetails={data.site_details}
          fccMoments={data.fcc_moments_details}
          isViewAllSite={isViewAllSite}
          handleViewAllSite={this.handleViewAllSite}
          {...this.props}
        />
        <div className="main-content">
          <div className="container">
            <div className="row">
              <Profile
                data={data}
                loading={loading}
                dataNotFound={dataNotFound}
                languagesData={languagesData}
                ratingData={ratingData}

              />
              <div className="container-right">
                {data && data.site_details && data.site_details.length > 0 && (
                  <MySites
                    siteDetails={data.site_details}
                    loading={loading}
                    dataNotFound={dataNotFound}
                    {...this.props}
                    isWrap={isViewAllSite}
                    handleViewAllSite={this.handleViewAllSite}
                    // isWrap={this.props.match && this.props.match.params && this.props.match.params.sites ? true :false }
                  />
                )}
                {data &&
                  data.certificates_details &&
                  data.certificates_details.length > 0 && (
                    <MyCertification
                      certficates={data.certificates_details}
                      loading={loading}
                      dataNotFound={dataNotFound}
                    />
                  )}
                {data &&
                  data.achievement_details &&
                  data.achievement_details.length > 0 && (
                    <MyAchievements
                      achievements={data.achievement_details}
                      loading={loading}
                      dataNotFound={dataNotFound}
                    />
                  )}
                {data &&
                  data.fcc_moments_details &&
                  data.fcc_moments_details.length > 0 && (
                    // <div style={{display:this.props.match && this.props.match.params && this.props.match.params.sites ? "none" : "block"}}>
                    <MyFCCMoments
                      fccMoments={data.fcc_moments_details}
                      loading={loading}
                      dataNotFound={dataNotFound}
                    />
                    // </div>
                  )}
                <RatingsReviews
                  modalOpen={this.modalOpen}
                  ratingData={ratingData}
                  ratingLoading={ratingLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <ReviewPopup
          modalClose={this.modalClose}
          uuid={this.props.match.params.uuid}
          getReview={this.getReview}
          setRatingLoading={this.setRatingLoading}
          isVisibleModal={isVisibleModal}
        />
      </div>
    );
  }
}

export default Main;
